// extracted by mini-css-extract-plugin
export default {"body1":"LandingPage_body1__ZYUqc","main":"LandingPage_main__VPd-O","button":"LandingPage_button__rQjXx","data":"LandingPage_data__XkKVn"};